"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESistAvalCalcExaF = exports.ESistAvalCalcRecF = exports.ESistAvalCalcRecP = exports.ESistAvalUsaVirgula = exports.ESistAvalNumeroEtapa = exports.ESistAvalTipoAva = void 0;
var ESistAvalTipoAva;
(function (ESistAvalTipoAva) {
    ESistAvalTipoAva["Avalia\u00E7\u00E3o por notas"] = "N";
    ESistAvalTipoAva["Avalia\u00E7\u00E3o por men\u00E7\u00E3o"] = "M";
})(ESistAvalTipoAva = exports.ESistAvalTipoAva || (exports.ESistAvalTipoAva = {}));
var ESistAvalNumeroEtapa;
(function (ESistAvalNumeroEtapa) {
    ESistAvalNumeroEtapa[ESistAvalNumeroEtapa["3 Trimestres"] = 3] = "3 Trimestres";
    ESistAvalNumeroEtapa[ESistAvalNumeroEtapa["4 Bimestres"] = 4] = "4 Bimestres";
})(ESistAvalNumeroEtapa = exports.ESistAvalNumeroEtapa || (exports.ESistAvalNumeroEtapa = {}));
var ESistAvalUsaVirgula;
(function (ESistAvalUsaVirgula) {
    ESistAvalUsaVirgula["N\u00E3o utilizar v\u00EDrgula"] = "1";
    ESistAvalUsaVirgula["Formatar com v\u00EDrgula"] = "2";
    ESistAvalUsaVirgula["Digitar com v\u00EDrgula"] = "3";
})(ESistAvalUsaVirgula = exports.ESistAvalUsaVirgula || (exports.ESistAvalUsaVirgula = {}));
var ESistAvalCalcRecP;
(function (ESistAvalCalcRecP) {
    ESistAvalCalcRecP["Somar as Notas"] = "O";
    ESistAvalCalcRecP["Manter a Maior Nota"] = "M";
    ESistAvalCalcRecP["M\u00E9dia Aritm\u00E9tica"] = "A";
    ESistAvalCalcRecP["Substituir a M\u00E9dia Bimestre"] = "S";
    ESistAvalCalcRecP["Substituir a Menor (Semestral)"] = "R";
})(ESistAvalCalcRecP = exports.ESistAvalCalcRecP || (exports.ESistAvalCalcRecP = {}));
var ESistAvalCalcRecF;
(function (ESistAvalCalcRecF) {
    ESistAvalCalcRecF["Considerar como Bimestre"] = "B";
    ESistAvalCalcRecF["Manter a Maior Nota"] = "M";
    ESistAvalCalcRecF["Substituir a M\u00E9dia Anual"] = "S";
    ESistAvalCalcRecF["M\u00E9dia Aritm\u00E9tica"] = "A";
})(ESistAvalCalcRecF = exports.ESistAvalCalcRecF || (exports.ESistAvalCalcRecF = {}));
var ESistAvalCalcExaF;
(function (ESistAvalCalcExaF) {
    ESistAvalCalcExaF["Somar as Nota"] = "O";
    ESistAvalCalcExaF["Manter a Maior Nota"] = "M";
    ESistAvalCalcExaF["Substituir a M\u00E9dia Anual"] = "S";
    ESistAvalCalcExaF["M\u00E9dia Aritm\u00E9tica"] = "A";
})(ESistAvalCalcExaF = exports.ESistAvalCalcExaF || (exports.ESistAvalCalcExaF = {}));
